import React from 'react'
import PropTypes from 'prop-types'

import { Colors } from '~/styles'

import Styled from '../../final-transshipment.styled'

const ReportTableHead = ({ gearlessColumns }) => {
  return (
    <Styled.Thead>
      <Styled.Tr>
        <Styled.Th rowSpan='2'>No</Styled.Th>
        <Styled.Th rowSpan='2'>Vessel</Styled.Th>
        <Styled.Th rowSpan='2'>Buyer</Styled.Th>
        <Styled.Th rowSpan='2'>SR. Number</Styled.Th>
        <Styled.Th rowSpan='2'>Geared</Styled.Th>
        <Styled.Th rowSpan='2'>Ratu Giok</Styled.Th>
        <Styled.Th
          colSpan={gearlessColumns.length || 0}
          rowSpan={gearlessColumns.length === 0 ? 2 : 1}
        >
          Gearless
        </Styled.Th>
        <Styled.Th rowSpan='2'>Total Gearless</Styled.Th>
        <Styled.Th rowSpan='2'>BL Qty</Styled.Th>
        <Styled.Th rowSpan='1'>BL Date</Styled.Th>
      </Styled.Tr>
      <Styled.Tr>
        {gearlessColumns.map((col, i) => (
          <Styled.Th
            backgroundColor={/giok/i.test(col) ? Colors.jadeGreen : Colors.deepSeaBlue}
            key={`gearless-${i}`}
          >
            {col}
          </Styled.Th>
        ))}
        <Styled.Th rowSpan='1' backgroundColor={Colors.deepSeaBlue}>Comp. LDG</Styled.Th>
      </Styled.Tr>
    </Styled.Thead>
  )
}

ReportTableHead.propTypes = {
  gearlessColumns: PropTypes.array.isRequired,
}

export default ReportTableHead